export const OFFICE_HEARTBEAT_MS = 30000;

const reportError = (...args) => window.console.error(...args);

export async function postOfficeHeartbeat({ fetchImpl = fetch, logError = reportError } = {}) {
  const response = await fetchImpl("/api/v1/app/Q3po/transactions", {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ app_release_id: 0, last_transaction_id: -1, transactions: [{ eventType: "StayInOffice", params: {}, appName: "Q3po" }] }),
  });
  if (!response.ok) {
    const detail = typeof response.text === "function" ? await response.text().catch(() => "") : "";
    const message = `[q3po] StayInOffice heartbeat failed (${response.status}) from a page outside the Q3po app; `
      + "this person drops out of the office after 3 minutes";
    logError(message, { status: response.status, detail: String(detail).slice(0, 300) });
    throw new Error(message);
  }
}
